import { IconButton, TextField } from "@mui/material";
import { LightTooltip } from "../LightToolTip/LightToolTip";
import { InputFieldProps } from "../../pages/ProfileSettings/types";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { styles } from "./styles";
import { TEXT_COLOR } from "../../theme";
const removeWhiteSpace = (text: string) => {
  return text.split(" ").join("");
};

function InputField({
  label,
  placeholder,
  type,
  disabled,
  error,
  value,
  onFocus,
  onchange,
  required,
  usernameError,
  metamask,
  isEmpty,
}: InputFieldProps): JSX.Element {
  if (isEmpty === true) {
    error = true;
  }

  return (
    <div className="space">
      <label
        htmlFor={removeWhiteSpace(label)}
        className="label__input"
        style={{ color: error ? "red" : TEXT_COLOR }}
      >
        {label}
        {required && (
          <span
            style={{ color: "red", fontSize: "1.2em", marginLeft: "0.1em" }}
          >
            *
          </span>
        )}
        {label === "username (stage name)" && (
          <LightTooltip
            enterTouchDelay={0}
            enterDelay={300}
            title="Stage name is permanent"
            placement="top"
          >
            <IconButton disableRipple>
              <HelpOutlineIcon color="info" style={{ height: 16, width: 16 }} />
            </IconButton>
          </LightTooltip>
        )}
      </label>
      <TextField
        inputProps={{ style: { fontFamily: "Argumentum" } }}
        value={value}
        style={
          metamask
            ? {
                borderColor: error ? "red" : "",
                color: "white",
                width: 330,
              }
            : {
                color: "white",
                borderColor: error ? "red" : "",
                marginBottom: "20px",
              }
        }
        type={type}
        sx={error ? styles.inputErrorFieldStyle : styles.inputFieldStyle}
        id={removeWhiteSpace(label)}
        name={removeWhiteSpace(label)}
        className="input__box"
        placeholder={placeholder}
        onChange={onchange}
        disabled={disabled}
        onFocus={onFocus}
      />
      {isEmpty ? (
        <span style={styles.emptySpan}>Field should not be empty</span>
      ) : (
        ""
      )}
      {error && !usernameError && !isEmpty ? (
        <span style={styles.numberCharacterErrorSpan}>
          Special characters, numbers, and spaces are not allowed
        </span>
      ) : (
        ""
      )}
      {usernameError && (
        <span style={styles.usernameErrorSpan}>Username already exists</span>
      )}
    </div>
  );
}

export default InputField;
